export const CORE_FEATURES = [
  "css-has",
  "css-container-queries",
  "css-nesting",
  "css-layer",
  "css-subgrid",
  "css-focus-visible",
  "html-dialog",
  "html-popover",
  "async-clipboard",
  "urlpattern",
  "api-view-transitions",
  "file-system-access",
];

export const POPULAR_FEATURES = [
  "css-has",
  "css-container-queries",
  "css-color-function",
  "css-color-mix",
  "css-text-wrap-balance",
  "html-img-loading",
  "html-inert",
  "async-clipboard",
  "web-share",
  "urlpattern",
  "api-view-transitions",
  "getdisplaymedia",
];

export const RISKY_FEATURES  = [
  "webgpu",
  "webusb",
  "webbluetooth",
  "webserial",
  "document-pip",
  "shared-array-buffer",
  "contact-picker",
];

export const EXPERIMENTAL_FEATURES  = [
  "css-scope",
  "css-anchor-positioning",
  "scheduler-post-task",
  "navigation-api",
  "abort-signal-any",
];
